import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useRolesStore = defineStore('roles', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getRoles: (state) => state.data?.data,
    getRoleOptions: (state) => state.options?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexRoleOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'roles', ['id', 'name', 'display_name', 'description']);
          const response = await axios.get('roles', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexRoles(params = {}) {
      try {
        const response = await axios.get('roles', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createRole(params = {}) {
      try {
        const response = await axios.get('roles/create', {params});
        return useCreateForm('roles', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showRole(roleId, params = {}) {
      try {
        const response = await axios.get(`roles/${ roleId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editRole(roleId, params = {}) {
      try {
        const response = await axios.get(`roles/${ roleId }/edit`, {params});
        return useEditForm(`roles/${ roleId }`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteRole(roleId, params = {}) {
      try {
        const response = await axios.delete(`roles/${ roleId }`, {params});
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Role Deleted',
          detail: `Role has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
